import Icon from "components/Elements/Icon/Icon.tsx";
import React, { useEffect, useRef, useState } from "react";
import useOnClickOutside from "hooks/useOnClickOutside.js";
import ActionComponentList from "./ActionComponentList.js";
import { useUser } from "contexts/userContext/userContext.js";

const BOTTOM_OFFSET = 30;

// extra actions for each row
export const HelperActions = ({
  details,
  currentPage,
  sizeNumber,
  setLoading,
  setSubUsers,
  setNumberOfUsers,
  fieldToOrder,
  orderAscending,
  isMobile = false,
}) => {
  const [actionsOpen, setActionsOpen] = useState(false);
  const [translateY, setTranslateY] = useState(0);
  const ref = useRef();
  const actionsContainerRef = useRef();
  const { getUserData } = useUser();
  useOnClickOutside(ref, () => setActionsOpen(false));

  useEffect(() => {
    if (actionsContainerRef.current) {
      const { top, height } =
        actionsContainerRef.current?.getBoundingClientRect();
      const pageHeight = document.body.clientHeight;
      const offsetFromTop = top + height;
      const bottomOffsetY =
        offsetFromTop > pageHeight
          ? offsetFromTop - pageHeight + BOTTOM_OFFSET
          : 0;
      setTranslateY(-bottomOffsetY);
    }
    return () => setTranslateY(0);
  }, [actionsContainerRef.current, actionsOpen]);

  // detect if registered user is admin and current user within the list is owner
  if (details.Permission === "owner" && !getUserData().isTopUser) {
    return null;
  }

  const enumActions = {
    active: [
      "UpdateUser",
      "OpenSubUserInbox",
      "ChangePermission",
      "ResetPassword",
      "AssignMailsToAnotherUser",
      "UnassignLicense",
      "Remove",
    ],
    suspended: ["AssignLicense", "Remove", "ResetPassword"],
    pending: ["Resend", "Remove"],
    expired: ["Resend", "Remove"],
  };

  let enumActionsList = enumActions[details.Status];

  if (details.Permission === "owner") {
    // owner only has assign to other mails
    enumActionsList = ["AssignMailsToAnotherUser"];
  } else if (React.isValidElement(details.Status)) {
    // if the status is a react element, it means that the user is pending
    enumActionsList = enumActions["pending"];
  }

  return (
    <>
      {enumActionsList ? (
        isMobile ? (
          <div className="mobile-actions">
            {
              <ActionComponentList
                actionList={enumActionsList}
                email={details.Email}
                firstName={details.FirstName}
                phoneNumber={details.Phone}
                profilePicture={details.ProfilePicture}
                currentPage={currentPage}
                sizeNumber={sizeNumber}
                setLoading={setLoading}
                setSubUsers={setSubUsers}
                setNumberOfUsers={setNumberOfUsers}
                fieldToOrder={fieldToOrder}
                orderAscending={orderAscending}
                isMobile={isMobile}
                permission={details.Permission}
                fullName={details.FullName}
              />
            }
          </div>
        ) : (
          <div ref={ref} className="table-actions">
            <div
              className="open-actions"
              onClick={() => setActionsOpen(!actionsOpen)}
            >
              <Icon name="dots-vertical" large />
            </div>
            <div
              className={`actions-container ${actionsOpen ? "open" : "close"}`}
              ref={actionsContainerRef}
              style={{
                transform: `translateY(${translateY}px)`,
              }}
              onClick={() => setActionsOpen(!actionsOpen)}
            >
              {
                <ActionComponentList
                  actionList={enumActionsList}
                  email={details.Email}
                  firstName={details.FirstName}
                  phoneNumber={details.Phone}
                  profilePicture={details.ProfilePicture}
                  currentPage={currentPage}
                  sizeNumber={sizeNumber}
                  setLoading={setLoading}
                  setSubUsers={setSubUsers}
                  setNumberOfUsers={setNumberOfUsers}
                  fieldToOrder={fieldToOrder}
                  orderAscending={orderAscending}
                  isMobile={isMobile}
                  permission={details.Permission}
                  fullName={details.FullName}
                />
              }
            </div>
          </div>
        )
      ) : null}
    </>
  );
};
